<template>
  <div class="div-componentePCDatosOrigenUnidadLogistica">
    <div
      v-if="unidadLogistica != null"
      class="div-contenidoPartidasDatosOrigen"
    >
      <!-- Cabecera Formulario -->
      <div
        class="div-cabeceraContenidoDatosPartidaOrigen"
      >
        <f7-row>
          <f7-col width="60">
            <span class="span-texto-teal-3">
              {{ $t('production.logisticUnitOriginData.labels.pallet', { text: unidadLogistica.NumeroSerie }) }}
            </span>
          </f7-col>
        </f7-row>
      </div>
      <div class="div-elementoSeparador-total" />
      <f7-row
        v-if="unidadLogistica.DatosOrigen"
        class="row-elementosContenidoDatosPartidaOrden"
      >
        <f7-col
          v-for="(datoOrigen, index) in unidadLogistica.DatosOrigen"
          :key="index"
          width="100"
        >
          <f7-col width="80">
            <span class="span-texto-gris-1">
              {{ `${$t('common.batch').toUpperCase()} ${datoOrigen.Partida.Serie}/${datoOrigen.Partida.Numero}` }}
            </span>
          </f7-col>
        </f7-col>
      </f7-row>
      <f7-row
        v-if="unidadLogistica.DatosOrigen == null || unidadLogistica.DatosOrigen.length === 0"
        class="row-elementosContenidoDatosPartidaOrden"
      >
        <f7-col width="100">
          <f7-col width="80">
            <span class="span-texto-gris-1">
              {{ $t('production.logisticUnitOriginData.labels.noData') }}
            </span>
          </f7-col>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';

export default {
  name: 'PCDatosOrigenUnidadLogistica',

  props: {
    actualizar: { type: Number, default: null }, // Contine la ultima fecha de actualización, al cambiar se dispara la actualizacion de datos.
    activo: { type: Boolean, default: true },
  },

  data() {
    return {
      unidadLogistica: null, // Contiene la unidad logistica sobre la que se cargaran los datos origen.
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, ['unidadLogisticaSeleccionada']),
  },
  watch: {
    actualizar(val) {
      if (val != null) {
        this.unidadLogistica = this.unidadLogisticaSeleccionada;
        this.ActualizarDatosOrigenUnidadLogistica();
      }
    },
    activo(val) {
      if (val != null && val === true) {
        this.unidadLogistica = this.unidadLogisticaSeleccionada;
        this.ActualizarDatosOrigenUnidadLogistica();
      }
    },
  },
  methods: {
    ActualizarDatosOrigenUnidadLogistica() {
      Log(this, this.ActualizarDatosOrigenUnidadLogistica.name);
      const self = this;
      PreloaderGH(true, true, this.$t('production.logisticUnitOriginData.loadingData.preloaderText'));
      this.CargarDatosOrigenDeUnidadLogistica(this.unidadLogistica.Id).then((result) => {
        PreloaderGH(false);
        self.unidadLogistica = result;
      })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Alert(error, this.$t('common.warning'));
        });
    },

    CargarDatosOrigenDeUnidadLogistica(idUnidadLogistica) {
      Log(this, this.CargarDatosOrigenDeUnidadLogistica.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerDatosPartidasOrigenDeUnaUnidadLogistica(idUnidadLogistica).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
          } else {
            HiNotification.Alert(result.Mensaje, this.$t('common.error'));
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            reject(error);
          });
      });
    },

  },

};
</script>

<style scoped>
.btn-informacionDatosOrigen {
  display: flex;
  float: right;
}

.div-ttlPartidadDelPale {
  display: flex;
  float: left;
}

.div-contenidoPartidasDatosOrigen {
  margin-top: 38px;
  margin-left: 16px;
  margin-right: 10px;
}

.row-elementosContenidoDatosPartidaOrden {
  margin-top: 10px;
}
</style>
